import { render, staticRenderFns } from "./_dialogEmailForm.vue?vue&type=template&id=08c75e16"
import script from "./_dialogEmailForm.vue?vue&type=script&lang=js"
export * from "./_dialogEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports